import React from 'react'
import { Link } from 'react-router-dom'
import CopyToClipboardUI from '../../../widgets/output/CopyToClipboardUI'
import LRTableActionsUI from '../../../widgets/layout/LRTableActionsUI'
import LRTableBodyUI from '../../../widgets/layout/LRTableBodyUI'
import LRTableRowUI from '../../../widgets/layout/LRTableRowUI'
import IconButtonUI from '../../../widgets/action/IconButtonUI'
import ButtonTinyUI from '../../../widgets/action/ButtonTinyUI'
import SpinnerUI from '../../../widgets/output/SpinnerUI'
import SearchUI from '../../../widgets/input/SearchUI'
import BadgeUI from '../../../widgets/output/BadgeUI'
import './AccountList.css'

const AccountListUI = ({ context, accountList, onRowClick, onRefreshClick,
  onDeleteClick, deleteSubmitted,
  onLoginClick, loginSubmitted, onOpenTdsStatusUpdateModal, selectedAccountId,
  searchFilter, onSearchFilterChange, onCopyToClipboard, copyToClipboardText,
  onCreateAccountClick
}) =>
  <div className='su_accs'>
    <LRTableActionsUI location='top'
      left={
        <ActionLeftUI
          context={context}
          onRefreshClick={onRefreshClick}
          onCreateAccountClick={onCreateAccountClick}
        />
      }
      right={
        <ActionRightUI
          context={context}
          searchFilter={searchFilter}
          onSearchFilterChange={onSearchFilterChange}
        />
      }
    />

    <div className='g_flex_h g_m_bottom_50'>
      <span>{accountList.length} account{accountList.length == 1 ? '' : 's'} displayed</span>
      <span className='g_muted g_small'>
        Search by account name or underwriter
      </span>
    </div>

    <LRTableBodyUI>
      {
        accountList.map((account, i) =>
          <AccountRowUI key={i} context={context} account={account} onRowClick={onRowClick}
            onDeleteClick={onDeleteClick}
            deleteSubmitted={deleteSubmitted}
            onLoginClick={onLoginClick}
            loginSubmitted={loginSubmitted}
            onOpenTdsStatusUpdateModal={onOpenTdsStatusUpdateModal}
            selectedAccountId={selectedAccountId}
            onCopyToClipboard={onCopyToClipboard}
            copyToClipboardText={copyToClipboardText}
          />
        )
      }
    </LRTableBodyUI>

  </div>

const AccountRowUI = ({ context, account, onRowClick,
  onDeleteClick, deleteSubmitted,
  onLoginClick, loginSubmitted, onOpenTdsStatusUpdateModal, selectedAccountId,
  onClick, onCopyToClipboard, copyToClipboardText
}) =>
  <LRTableRowUI
    context={context}
    left={<RowLeftUI context={context} account={account}
      onCopyToClipboard={onCopyToClipboard}
      copyToClipboardText={copyToClipboardText}
    />}
    right={<RowRightUI context={context} account={account}
      onDeleteClick={onDeleteClick} deleteSubmitted={deleteSubmitted}
      onLoginClick={onLoginClick} loginSubmitted={loginSubmitted}
      onOpenTdsStatusUpdateModal={onOpenTdsStatusUpdateModal}
      selectedAccountId={selectedAccountId}
    />}
    onClick={onRowClick}
    rowId={account.accountId}
  />

const RowLeftUI = ({ context, account, onCopyToClipboard, copyToClipboardText }) =>
  <div className='g_flex_v'>
    <span>
      <b>{account.accountName}</b>
      {
        account.businessName &&
        <span> ({account.businessName})</span>
      }
      <span className='g_m_left_100'><i>{account.testAccount ? 'test' : ''}</i></span>
    </span>
    <span className='g_flex_h g_muted g_flex_left'>
      <span className='g_m_right_100'>{account.dateCreatedF1}</span>
      <CopyToClipboardUI text={account.accountId}
        onCopyToClipboard={onCopyToClipboard} copyToClipboardText={copyToClipboardText}
      />
    </span>
    {
      account.assignedUserName &&
      <span className='g_muted'>Assigned to: {account.assignedUserName}</span>
    }
  </div>

const RowRightUI = ({ context, account, onDeleteClick, deleteSubmitted, onLoginClick, loginSubmitted, onOpenTdsStatusUpdateModal, selectedAccountId }) =>
  <div>
    {
      context && context.permissions.includes('su_superuser') &&
      !account.panNumber &&
      <span className='g_flex_h g_flex_right'>
        <SpinnerUI show={deleteSubmitted && selectedAccountId === account.accountId} reserveSpace={true} />
        <ButtonTinyUI label='Delete' rowId={account.accountId} onClick={onDeleteClick} />
      </span>
    }
    {
      account.nachTransfer &&
      <span className='g_m_left_50'><BadgeUI label='nach' /></span>
    }
    {
      account.kycCompleted &&
      <span className='g_m_left_50'><BadgeUI label='kyc complete' /></span>
    }
    {
      account.kycCompleted && account.status === 'frozen' &&
      <span className='g_m_left_50'><BadgeUI label='frozen' /></span>
    }
    {
      account.panNumber && !account.kycCompleted &&
      <span className='g_m_left_50'><BadgeUI label='pan scanned' /></span>
    }
    {
      account.womanLed &&
      <span className='g_m_left_50'><BadgeUI label='women-led' /></span>
    }
    {
      account.appOnboardingStatus !== null &&
      <span className='g_m_left_50'><BadgeUI label={account.appOnboardingStatus} /></span>
    }
    {
      account.creditTag &&
      <span className='g_m_left_50'><BadgeUI label={account.creditTag} /></span>
    }
    <div className='g_m_top_25' >
      <span className='g_flex_h g_flex_right'>
        {account.kycCompleted ? (
          <>
            <SpinnerUI show={loginSubmitted && selectedAccountId === account.accountId} reserveSpace={true} />
            <Link to='#' data-row-id={account.accountId} onClick={onLoginClick}>Data</Link>
          </>
        ) : <span />}
      </span>
      {
        context && context.permissions.includes('su_superuser_business') &&
        <span className='g_flex_h g_flex_right'>
          <Link
            to='#'
            data-row-id={account.accountId}
            onClick={onOpenTdsStatusUpdateModal}
          >
            {account && account.tdsStatus ? 'Disable TDS' : 'Enable TDS'}
          </Link>
        </span>
      }
      {/*
        <Link to={`/su/accounts/${account.accountId}/events`} className='g_m_left_100' onClick={e => e.stopPropagation()}>
          Events
        </Link>
        */}
    </div>
  </div>

const ActionLeftUI = ({ context, onRefreshClick, onCreateAccountClick }) =>
  <div className='g_flex_h'>
    <IconButtonUI icon='icon-refresh' onClick={onRefreshClick} />
    <IconButtonUI icon='icon-plus' onClick={onCreateAccountClick} />
    <span className='g_m_left_100 g_large'><b>Accounts</b></span>
  </div>

const ActionRightUI = ({ context, searchFilter, onSearchFilterChange }) =>
  <SearchUI value={searchFilter} onChange={onSearchFilterChange} />

export default AccountListUI
